import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { PickupContactPropType } from '../../../prop-types/pickup-contact';

import style from '../dropdown-style.module.less';
import { noop } from 'ui-components/default-props/noop';

export const ContactDropdownItem = ({ contact, onContactSelected = noop, selectedContactId = null }) => {
  const onClick = useCallback(() => onContactSelected(contact), [contact, onContactSelected]);
  return (
    <DropdownMenuItem key={contact.shipFromContactId} onClick={onClick} selected={contact.shipFromContactId === selectedContactId}>
      <div className={style.title}>{`${contact.firstName} ${contact.lastName}`}</div>
      <div className={style.subtitle}>
        {`${contact.phoneNumber} ${contact.phoneNumberExtension}`}
        <br />
        {contact.emailAddress}
      </div>
    </DropdownMenuItem>
  );
};

ContactDropdownItem.propTypes = {
  contact: PickupContactPropType.isRequired,
  onContactSelected: PropTypes.func,
  selectedContactId: PropTypes.string,
};
